import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { Field } from 'src/app/models/field';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.css']
})
export class TextFieldComponent implements OnInit  {

  date:string="";
  readOnlyInput=false;
  formattedDate: string|undefined;

  @Input() formGroup: UntypedFormGroup|undefined;
  @Input({required:true})
  hidden:boolean|undefined=false;


  constructor(private datePipe: DatePipe){

  }

  ngOnInit(): void {

    
    
    if (this.field?.textFieldType == "date") {
      
      if(this.formGroup?.get(this.fieldId!)?.value && this.formGroup?.get(this.fieldId!)?.value!="NaN/NaN/NaN"){
        this.field.value = this.formGroup?.get(this.fieldId!)?.value;
      }

      if (this.field.editable == false) {
        this.formGroup?.get(this.fieldId!)?.disable();
      }
  
      if (this.field?.value) {
        
        const rawDate = this.field.value;
        
        // Check if the date is already in the 'dd/MM/yyyy' format
        const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
        
        if (dateFormatRegex.test(rawDate)) {
          // If the format is 'dd/MM/yyyy', assign it directly
          this.date = rawDate;
        } else {
          // Otherwise, parse and format it to 'dd/MM/yyyy'
          const parsedDate = new Date(rawDate);
          this.date = this.datePipe.transform(parsedDate, 'yyyy/MM/dd')!;
        }
      }
    }
  }
  



  @Input()
  field!: Field;

  @Input()
  isUserType:boolean=false;

  @Input()
  fieldId:string|undefined;

  @Input()
  calculationFields:Field[]=[];

  @Input()
  yourTurn:boolean|undefined;

  @Input()
  submitted:boolean|undefined;

  @Input()
  control!: any;

  @Input()
  errors:any;

  @Input()
  isInvalid:boolean=false;

  @Input()
  containerFieldId:string|undefined=undefined;

  @Input()
  fieldIndex:number|undefined=undefined;

  @Input()
  isContainer:boolean=false;

  @Output()
  calulcateTextField:EventEmitter<string>=new EventEmitter<string>;


  updateIsUserType(){
    if(this.formGroup?.get(this.fieldId!)?.value!="" && this.formGroup?.get(this.fieldId!)?.value!=null){
      this.isUserType=true;
    }else{
      this.isUserType=false;
    }

    this.calculate();
    
  } 

  calculate() {

    const baseId = this.field.id.replace(/#.*$/, '');

    this.calulcateTextField.emit(baseId);
  }




  getTextFieldType(tpye:string):string{

    if(tpye=="text"){
      return "text";
    }
    else if(tpye=="integer"){
      return "number";
    }
    else if(tpye=="decimal"){
      return "number";
    }
    else if(tpye=="password"){
      return "password";
    }
    else if(tpye=="date"){
      return "date";
    }else{
      return "text";
    }

  }

  @Output() 
  refreshFormEvent:EventEmitter<{fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean}>=new EventEmitter<{fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean}>();


  refreshForm(fieldId: string, shouldRefresh: boolean,containerFieldId:string|undefined,fieldIndex:number|undefined,isContainer:boolean){

    if(this.isUserType){
      this.refreshFormEvent.emit({ fieldId ,shouldRefresh,containerFieldId,fieldIndex,isContainer});
    }

    if(this.field.textFieldType=="date"){
      this.refreshFormEvent.emit({ fieldId ,shouldRefresh,containerFieldId,fieldIndex,isContainer});
    }

  }

}
